import React, { useEffect, useState } from "react";

export function PdfPreview({ dataUrl, orderId }) {
  const [blobUrl, setBlobUrl] = useState(null);
  useEffect(() => {
    let url;
    try {
      // Convert data:application/pdf;base64,... to a Blob URL for reliable in-browser PDF rendering
      const [header, b64] = dataUrl.split(",");
      const mime = (header.match(/data:([^;]+)/) || [])[1] || "application/pdf";
      const bin = atob(b64);
      const bytes = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
      const blob = new Blob([bytes], { type: mime });
      url = URL.createObjectURL(blob);
      setBlobUrl(url);
    } catch (e) { console.error("Could not decode proof PDF", e); }
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [dataUrl]);
  if (!blobUrl) return <div className="text-xs text-[color:var(--text-muted)]">Loading PDF…</div>;
  return (
    <div data-testid={`proof-pdf-wrap-${orderId}`}>
      <object data={blobUrl} type="application/pdf" className="w-full h-[520px] rounded border hairline bg-white">
        <iframe src={blobUrl} title="Proof PDF" className="w-full h-[520px] rounded border hairline bg-white"/>
      </object>
      <div className="flex gap-3 mt-2 text-xs">
        <a href={blobUrl} target="_blank" rel="noopener noreferrer" className="underline" style={{color: "var(--accent-metal)"}}>Open in new tab</a>
        <a href={dataUrl} download={`proof-${orderId}.pdf`} className="underline" style={{color: "var(--accent-metal)"}}>Download</a>
      </div>
    </div>
  );
}
